import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_outdoor_garden: FaireThemeEntity = {
  token: "discovery_theme_outdoor-garden",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Outdoor & Garden",
  description: "Green-thumb favorites for patio and yard",
  bgColor: "#D4E8C8",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
